import React from "react";

export const LanguageContext = React.createContext({
  language: "nl",
  toggleLanguage: console.log,
});
